/**
 * @type {angular}
 */
module.exports = window.angular.module("BrowserSync");
